import script from "./ShortcutKey.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutKey.vue?vue&type=script&setup=true&lang=js"

import "./ShortcutKey.vue?vue&type=style&index=0&id=37d6d92b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d6d92b"]])

export default __exports__